export const SUBTITLE_SIDECAR_FILE_PICKER_TYPES = [
  {
    description: 'Subtitle files',
    accept: {
      'application/x-subrip': ['.srt'],
      'text/vtt': ['.vtt'],
      'text/plain': ['.srt', '.vtt'],
    },
  },
] satisfies FilePickerAcceptType[]

export function hasSubtitleSidecarFilePickerSupport(): boolean {
  return typeof window !== 'undefined' && 'showOpenFilePicker' in window
}

export async function showSubtitleSidecarFilePicker(): Promise<FileSystemFileHandle[]> {
  return window.showOpenFilePicker({
    multiple: false,
    types: SUBTITLE_SIDECAR_FILE_PICKER_TYPES,
  })
}